(function() {
  'use strict';
  
  // 1. Preconnect to critical domains
  const domains = ['https://cdn.shopify.com', 'https://fonts.googleapis.com'];
  domains.forEach(domain => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = domain;
    document.head.appendChild(link);
  });
  
 // 2. Lazy load images with dynamic content support
  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.classList.remove('lazy');
          img.classList.add('loaded');
          imageObserver.unobserve(img);
        }
      }
    });
  });
  
  // Function to initialize lazy loading for new images
  function initializeLazyImages(container = document) {
    const lazyImages = container.querySelectorAll('img[data-src]:not(.observed)');
    lazyImages.forEach(img => {
      img.classList.add('observed'); // Mark as observed to avoid duplicates
      imageObserver.observe(img);
    });
  }
  
  // 3. Browser caching with Cache API
  if ('caches' in window) {
    window.addEventListener('load', async () => {
      try {
        const cache = await caches.open('indolady-v1');
        const urlsToCache = [
          'https://indolady.in/cdn/shop/t/16/assets/vendor-swiper.bundle.min.js?v=57636454815115923131756122736',
          'https://indolady.in/cdn/shop/t/16/assets/sections.js?v=122388609572892525011756980312',
          window.location.href
        ];
        await cache.addAll(urlsToCache);
      } catch (error) {
        console.log('Cache failed:', error);
      }
    });
  }
  
  // 4. Initialize lazy loading for initial content
  document.addEventListener('DOMContentLoaded', () => {
    initializeLazyImages();
  });
  
  // 5. Watch for dynamically loaded content (MutationObserver)
  const contentObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            // Check if the added node contains lazy images
            if (node.querySelector && node.querySelector('img[data-src]')) {
              initializeLazyImages(node);
            }
            // Check if the added node itself is a lazy image
            if (node.tagName === 'IMG' && node.dataset.src) {
              imageObserver.observe(node);
            }
          }
        });
      }
    });
  });
  
  // Start observing the document for changes
  contentObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // 6. Prefetch next page resources
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="/"]');
    if (link) {
      const prefetchLink = document.createElement('link');
      prefetchLink.rel = 'prefetch';
      prefetchLink.href = link.href;
      document.head.appendChild(prefetchLink);
    }
  });
  
  // 7. Expose function globally for manual triggering
  window.initializeLazyImages = initializeLazyImages;
  
})();
